import { generateTheme } from '../theme';
export const getCurrentMenu = (process.env.REACT_APP_MENU as string) || 'gapstack';
export const sideBarConfig: string =
    process.env.REACT_APP_SIDE_BAR_CONFIG || '11-111[11111][11111]-[11111][11111]1-1-111';
export const enabledRouteArray = sideBarConfig.replaceAll('[', '').replaceAll(']', '').split('');
export const colorTheme = generateTheme();
